import React from 'react';
import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from '@mui/material';
import FormatBold from '@mui/icons-material/FormatBold';
import FormatItalic from '@mui/icons-material/FormatItalic';

export interface LoginTextStyle {
  fontFamily?: string;
  fontSize?: string;
  fontWeight?: string | number;
  fontStyle?: string;
  color?: string;
}

const FONT_OPTIONS = [
  'Inter',
  'Roboto',
  'Open Sans',
  'Lato',
  'Montserrat',
  'Poppins',
  'Nunito',
  'Oswald',
  'Raleway',
  'Arial',
];

const parseFontSize = (value?: string) => {
  const matched = String(value || '').match(/\d+/);
  return matched ? matched[0] : '';
};

interface LoginTextStyleRowProps {
  label: string;
  value: LoginTextStyle;
  fallbackColor?: string;
  onChange: (next: LoginTextStyle) => void;
}

const LoginTextStyleRow: React.FC<LoginTextStyleRowProps> = ({
  label,
  value,
  fallbackColor = '#111827',
  onChange,
}) => {
  const formats = [
    ...(String(value.fontWeight) === 'bold' || Number(value.fontWeight) >= 600 ? ['bold'] : []),
    ...(value.fontStyle === 'italic' ? ['italic'] : []),
  ];

  return (
    <Box sx={{ mb: 2, p: 1.5, border: '1px solid', borderColor: 'divider', borderRadius: 1 }}>
      <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 1 }}>
        {label}
      </Typography>
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, alignItems: 'center' }}>
        <FormControl size="small" sx={{ minWidth: 140, flex: 1 }}>
          <InputLabel>Yazı tipi</InputLabel>
          <Select
            label="Yazı tipi"
            value={value.fontFamily || ''}
            onChange={(e) => onChange({ ...value, fontFamily: e.target.value })}
          >
            <MenuItem value="">
              <em>Varsayılan</em>
            </MenuItem>
            {FONT_OPTIONS.map((font) => (
              <MenuItem key={font} value={font} sx={{ fontFamily: font }}>
                {font}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <TextField
          size="small"
          type="number"
          label="Boyut"
          value={parseFontSize(value.fontSize)}
          onChange={(e) =>
            onChange({
              ...value,
              fontSize: e.target.value ? `${e.target.value}px` : '',
            })
          }
          sx={{ width: 88 }}
        />
        <Box
          component="input"
          type="color"
          value={value.color || fallbackColor}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange({ ...value, color: e.target.value })}
          sx={{
            width: 40,
            height: 40,
            p: 0,
            border: '1px solid',
            borderColor: 'divider',
            borderRadius: 1,
            bgcolor: 'transparent',
            cursor: 'pointer',
          }}
        />
        <ToggleButtonGroup size="small" value={formats}>
          <ToggleButton
            value="bold"
            onClick={() =>
              onChange({
                ...value,
                fontWeight: formats.includes('bold') ? 'normal' : 'bold',
              })
            }
          >
            <FormatBold fontSize="small" />
          </ToggleButton>
          <ToggleButton
            value="italic"
            onClick={() =>
              onChange({
                ...value,
                fontStyle: formats.includes('italic') ? 'normal' : 'italic',
              })
            }
          >
            <FormatItalic fontSize="small" />
          </ToggleButton>
        </ToggleButtonGroup>
      </Box>
    </Box>
  );
};

export default LoginTextStyleRow;
